export default "__VITE_PUBLIC_ASSET__9eea2f7b__"